import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { reducer as oidcReducer } from 'redux-oidc'

import { reducers as authReducers } from '@cinch/oxd-redux/auth/src'
import { reducers as checkoutReducers } from '@cinch/oxd-redux/checkout/src'
import { reducers as compareReducers } from '@cinch/oxd-redux/compare/src'
import { reducers as dealerVehicleReducers } from '@cinch/oxd-redux/dealer-vehicles/src'
import { reducers as financeReducers } from '@cinch/oxd-redux/finance/src'
import { reducers as lifestyleReducers } from '@cinch/oxd-redux/lifestyle/src'
import { reducers as partnersReducers } from '@cinch/oxd-redux/partners/src'
import { reducers as paymentReducers } from '@cinch/oxd-redux/payments/src'
import { reducers as profileReducers } from '@cinch/oxd-redux/profile/src'
import { reducer as searchReducer } from '@cinch/oxd-redux/search/src'
import { reducers as vehicleReducers } from '@cinch/oxd-redux/vehicles/src'

const reducer = combineReducers({
  auth: authReducers.domain,
  checkout: combineReducers(checkoutReducers as any),
  compare: compareReducers.domain,
  dealerVehicle: dealerVehicleReducers.domain,
  entities: combineReducers({
    ...vehicleReducers.entities,
    ...dealerVehicleReducers.entities,
    ...profileReducers.entities,
  } as any),
  finance: financeReducers,
  form,
  lifestyle: lifestyleReducers.domain,
  oidc: oidcReducer,
  partners: partnersReducers.domain,
  payment: paymentReducers,
  profile: profileReducers.domain,
  search: searchReducer,
  vehicle: vehicleReducers.domain,
} as any)

export default reducer
